/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React, { useEffect, useState, createContext } from 'react';
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

import { Banner } from './components/Banner';

import { aemhContentTransformation } from './aemhContentTransformation';

export const ContextServiceTracking = createContext<TrackingServiceV2 | undefined>(undefined);

// eslint-disable-next-line no-undef
export const FeatureApp: React.FC<FeatureAppProps> = ({
  serviceTracking,
  serviceContent,
  // eslint-disable-next-line no-undef
}: FeatureAppProps) => {
  // eslint-disable-next-line no-undef
  const [content, setContent] = useState(serviceContent.getContent() as unknown as ContentAem);
  useEffect(() => {
    serviceContent.onContentChange(() => {
      // eslint-disable-next-line no-undef
      setContent(serviceContent.getContent() as unknown as ContentAem);
    });
  }, [serviceContent]);

  return (
    <ContextServiceTracking.Provider value={serviceTracking}>
      <Banner {...aemhContentTransformation(content)} />
    </ContextServiceTracking.Provider>
  );
};

export default FeatureApp;
